import { formatDate } from "../../../../utils/DateFormat";

export const ORIGINAL_PROFILE_PAGE_SIZE = 10;

export const toApiDate = (dateStr) => {
  if (!dateStr) return undefined;

  const [day, month, year] = dateStr.split("-");
  if (!day || !month || !year) return undefined;

  return `${year}-${month}-${day}`;
};

export const validateDateRange = (fromDate, toDate) => {
  if (toDate && !fromDate) return "Vui lòng nhập ngày bắt đầu.";
  if (fromDate && !toDate) return "Vui lòng nhập ngày kết thúc.";

  const from = fromDate
    ? new Date(fromDate.split("-").reverse().join("-"))
    : null;
  const to = toDate ? new Date(toDate.split("-").reverse().join("-")) : null;

  if (from && to && from > to) {
    return "Ngày bắt đầu không được lớn hơn ngày kết thúc.";
  }

  return "";
};

export const buildOriginalProfileListParams = ({
  page,
  limit,
  search,
  fromDate,
  toDate,
  clientId,
}) => ({
  page,
  limit,
  search_value: search || undefined,
  fromDate: toApiDate(fromDate),
  toDate: toApiDate(toDate),
  clientId: clientId || undefined,
});

export const buildOriginalProfileChartParams = ({
  fromDate,
  toDate,
  clientId,
}) => ({
  fromDate: toApiDate(fromDate),
  toDate: toApiDate(toDate),
  clientId: clientId || undefined,
});

export const buildOriginalProfileExportParams = ({
  search,
  fromDate,
  toDate,
  clientId,
}) => ({
  search_value: search || undefined,
  fromDate: toApiDate(fromDate),
  toDate: toApiDate(toDate),
  clientId: clientId || undefined,
});

export const normalizeOriginalProfileChart = (chart = []) => {
  if (!Array.isArray(chart)) return [];

  const normalized = chart.map((item) => ({
    serviceId: item.serviceId,
    label: item.label || item.serviceName || "Không xác định",
    value: Number(item.value || item.count || 0),
    percent: Number(item.percent || 0),
  }));

  const total = normalized.reduce((sum, item) => sum + item.value, 0);

  if (!total) return normalized;

  return normalized.map((item) => ({
    ...item,
    percent: item.percent || Number(((item.value / total) * 100).toFixed(1)),
  }));
};

export const getOriginalProfilePreview = (profile) => {
  const imageLogo = profile?.logo?.find((item) => item?.isImage && item?.value);

  if (imageLogo?.value) return imageLogo.value;
  if (profile?.image?.url) return profile.image.url;
  if (typeof profile?.image === "string") return profile.image;

  return "/images/default-profile.png";
};

export const formatOriginalProfileRows = ({
  profiles = [],
  currentPage,
  pageSize,
}) =>
  profiles.map((profile, index) => ({
    id: pageSize * (currentPage - 1) + index + 1,
    mau: getOriginalProfilePreview(profile),
    ten: profile.brand || "--",
    soDon: profile.profileCode || "--",
    ngayNopDon: formatDate(profile.createdDate || profile.createdAt),
    soBang: profile.numberOfCertificates || "--",
    phanLoai: profile.groupNames?.length ? profile.groupNames.join("; ") : "--",
    chuSoHuu: profile.owner?.length ? profile.owner.join("; ") : "--",
    trangThai: profile.status || "Chưa có trạng thái",
    nav_id: profile._id,
  }));

export const getOriginalProfileTotal = (pagination, chartData) => {
  if (typeof pagination?.totalProfiles === "number") {
    return pagination.totalProfiles;
  }

  return chartData.reduce((sum, item) => sum + Number(item.value || 0), 0);
};
